export const slideData = [
  {
    description:
      "Their clinical care is outstanding but what really sets them apart is that they truly care about the well-being of their patients.",
    title: "Linda Cardellini",
  },
  {
    description:
      "I feel like the team really cares about my personal health and feels invested in my well-being into the future.",
    title: "Andrew Mcgregor",
  },
  {
    description:
      "I just can’t say enough good things about the Medical Clinic. I am so happy to be a patient there. It saved my life.",
    title: "Kevin Noon",
  },
];
